import Page from '@sellermodules/register/pages/default';

export default Page;
